import React, { useEffect } from "react";
import { emitter, CommandLaunchEvent } from "../../input/AppEvents";
import CommandIdEnum from "../../enums/CommandIdEnums";
import createCommand from "../../commands/commandFactory";
import { useServicesState } from "../../store/servicesStateStore";
import { useDocumentsStateStore } from "../../store/documentsStateStore";
import IParameterizable from "../../interfaces/IParameterizable";

const CommandManager = () => {

    const {canvasInputListener, commandStack } = useServicesState();
    const { getActiveDocument } = useDocumentsStateStore();

     // On first render
     useEffect(() => {

        // Subscribe to the event
        const launchCommand = ({ commandId, parameters }: CommandLaunchEvent) => {
          const currentCmd = commandStack.getCurrentCmd();
          if (currentCmd && !currentCmd.canLaunch(commandId)) {
            console.info(`Cannot launch command ${CommandIdEnum[commandId]}. There is already ${CommandIdEnum[currentCmd.getId()]} command running`);
            return;
          }

              const doc = getActiveDocument();
              if (!doc) {
                console.error("No active document found");
                return;
              }

              const cmd = createCommand(commandId, canvasInputListener, doc.document);
              if (cmd) {
                  if (parameters !== undefined && 'setParameters' in cmd)
                      (cmd as unknown as IParameterizable<unknown>).setParameters(parameters);
                  cmd.start();
              }
        };

        const stopCommand = () => {
            const currentCmd = commandStack.getCurrentCmd();
            if (currentCmd) {
                currentCmd.end();
            }
          };


        const notifyCmdOnViewerModeChange = () => {
            const currentCmd = commandStack.getCurrentCmd();
            if (currentCmd) {
                ;
            }
          };


        emitter.on('commandLaunch', launchCommand);
        emitter.on('commandStop', stopCommand);
        emitter.on('viewerModeChange', notifyCmdOnViewerModeChange);
        
        // Cleanup on unmount
        return () => {
          emitter.off('commandLaunch', launchCommand);
          emitter.off('commandStop', stopCommand);
          emitter.off('viewerModeChange', notifyCmdOnViewerModeChange);
        };

      }, []);

    return <>
        
    </>

};

export default CommandManager;


